// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UkLQ7hEpAJ0x7YlyvhaG{justify-content:space-between;align-items:center;gap:16px;width:100%;max-width:760px;margin:8px auto -8px;padding:8px 0 0 8px;display:flex}.a7rzmPIjM6wv4Xr6WP8f{justify-content:flex-start;align-items:center;gap:8px;margin-right:auto;display:flex}.ldLQtvzPeMZwJFMApJNz{justify-content:flex-start;align-items:center;gap:8px;margin-left:auto;display:flex}.ldLQtvzPeMZwJFMApJNz button:focus-visible{box-shadow:inset 0 0 0 1px var(--interaction-brand-active),0 0 0 3px var(--light-blue-20)}.M1mQM17GBwOZ10pEEp5Y{flex-direction:column;gap:4px;display:flex}.bOoRmtqP_cgNB8ZvQzIo{cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `UkLQ7hEpAJ0x7YlyvhaG`,
	"left": `a7rzmPIjM6wv4Xr6WP8f`,
	"right": `ldLQtvzPeMZwJFMApJNz`,
	"tooltipContent": `M1mQM17GBwOZ10pEEp5Y`,
	"settingsLink": `bOoRmtqP_cgNB8ZvQzIo`
};
export default ___CSS_LOADER_EXPORT___;
